import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartOptions
  } from 'chart.js';
import { useMemo, useState, useEffect } from "react";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { Bar } from "react-chartjs-2";
import { IDataDashboardComercial } from "../../../../../types/api/comercial/dashboard";
import { Box, Typography } from "@mui/material";
import SelectLoja from "../../../../../components/SelectsSimpleApiQuery/SelectLoja";
import { IDataLojas } from "../../../../../types/api/geral/pesquisar-lojas";
import { useContext } from "react";
import { AuthContext } from "../../../../../contexts/AuthContext";
import moment from "moment";
import DateComIntervalo from '../../../../../components/DateComIntervalo';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default function CardGraficoPedidosVenda({
    dataDashboard,
    loja,
    onChangeLoja,
    onChangePeriodo,
    currentPeriodo
}: CardGraficoPedidosVendaProps) {
    const { userPerfilComLoja } = useContext(AuthContext);
    
    const defaultPeriodo = {
        inicial: moment().subtract(6, 'days').startOf('day'),
        final: moment().endOf('day')
    };
    
    const [selectedPeriodo, setSelectedPeriodo] = useState(currentPeriodo || defaultPeriodo);
    
    useEffect(() => {
        if (currentPeriodo) {
            setSelectedPeriodo(currentPeriodo);
        }
    }, [currentPeriodo]);
    const labels = Object.keys(dataDashboard.grafico_dias_pedidos_emitidos_faturados);
    const values = Object.values(dataDashboard.grafico_dias_pedidos_emitidos_faturados);
    const emitidos = values.map(item => item.emitidos);
    const faturados = values.map(item => item.faturados);
    const options: ChartOptions<'bar'> = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };
    const dataGrafico = useMemo(() => ({
        labels,
        datasets: [
            {
                label: 'Pedidos emitidos',
                data: emitidos,
                borderColor: '#4B89DC',
                backgroundColor: '#4B89DC',
                fill: true
            },
            {
                label: 'Pedidos faturados',
                data: faturados,
                borderColor: '#dc4b4b',
                backgroundColor: '#dc4b4b',
                fill: true
            },
        ],
    }), [labels, dataDashboard]);

    function handleChangePeriodo(values: { inicial: moment.Moment | null; final: moment.Moment | null }): void {
        setSelectedPeriodo(values);
        
        if (typeof onChangePeriodo === 'function') {
            onChangePeriodo(values);
        }
    }

    return (
        <PaperBox style={{ height: '100%' }} p={2}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography variant='h6'>Pedidos de venda</Typography>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <SelectLoja
                        value={loja}
                        onChange={onChangeLoja}
                        extraParams={{ somente_vinculadas: Boolean(userPerfilComLoja?.loja) }}
                        required={false}
                        label="Selecionar Loja"
                        possuiBtnLimpar={true}
                        size="small"
                    />
                </div>
            </div>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexDirection={{ xs: "column-reverse", md: "row" }}
                gap={1}
            >
                <Box width="300px">
                    <DateComIntervalo
                        size="small"
                        data={{
                            inicial: selectedPeriodo.inicial,
                            final: selectedPeriodo.final
                        }}
                        onChangeData={handleChangePeriodo}
                    />
                </Box>
            </Box>
            <div style={{ marginLeft: 8 }}>
                <Bar options={options} data={dataGrafico} />
            </div>
        </PaperBox>
    )
}
interface CardGraficoPedidosVendaProps {
    dataDashboard: IDataDashboardComercial;
    loja: IDataLojas | null;
    onChangeLoja: (loja: IDataLojas | null) => void;
    onChangePeriodo: (values: { inicial: moment.Moment | null; final: moment.Moment | null }) => void;
    currentPeriodo?: { inicial: moment.Moment | null; final: moment.Moment | null };
}
